<script lang="ts">
  import EmployeesUnified from '../../components/employer/employees/EmployeesUnified.svelte';
</script>

<div class="employees-page">
  <EmployeesUnified />
</div>